import React, { HTMLProps } from "react";
import "./chip.css";
import { Tooltip, TooltipProps } from "@material-ui/core";

interface ChipProps extends HTMLProps<HTMLDivElement> {
    children?: React.ReactNode;
    tooltip?: string;
}

type TooltipCompProps<T> = T extends TooltipProps ? Omit<TooltipProps, "children"> : HTMLProps<React.ReactFragment>;

export const Root = ({ children, tooltip, ...rest }: ChipProps) => {
    const TooltipComp: React.ComponentType<TooltipProps | React.ReactFragment> = tooltip ? Tooltip : React.Fragment;
    const tooltipProps = tooltip
        ? ({ title: tooltip } as TooltipCompProps<TooltipProps>)
        : ({} as TooltipCompProps<React.ReactFragment>);

    return (
        <TooltipComp {...tooltipProps}>
            <div {...rest} className="chip__container">
                {children}
            </div>
        </TooltipComp>
    );
};

interface ChipTextProps extends HTMLProps<HTMLDivElement> {
    children: React.ReactNode;
}

export const Text = ({ children }: ChipTextProps) => {
    return <div className="chip__text">{children}</div>;
};
